import { Vue } from 'vue-property-decorator'

export const recurrenceType = () => {
  return {
    ONE_TIME: { key: 50510001, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510001') },
    DAILY: { key: 50510002, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510002') },
    WEEKLY: { key: 50510003, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510003') },
    BIWEEKLY: { key: 50510004, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510004') },
    MONTHLY: { key: 50510005, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510005') },
    CUSTOM: { key: 50510006, label: Vue.prototype.$gettext('RECURRENCE_TYPE.50510006') }
  }
}
